import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";

function NavigateControl() {
  const { t } = useTranslation();
  return (
    <li className={""}>
      <Tooltip placement="top" title="显示/隐藏" color="#8c8c8c">
        <div className="close"></div>
      </Tooltip>
      <div
        className="text"
        onClick={() => {
          window.open("http://arcticroute.tpdc.ac.cn/navigate");
        }}
      >
        {t("analysis.shippingRoutePlanning")}
      </div>
      <div className="button">
        <span className="list_icon1"></span>
        <span className="list_icon2"></span>
        <span className="list_icon3"></span>
      </div>
    </li>
  );
}

export default NavigateControl;
